import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { RequiresAuthenticatedUser } from '../../RequiresAuthenticatedUser';
import AccountsStore from '../../../stores/AccountsStore';
import ProjectionStore from '../../../stores/ProjectionStore';
import { ProjectionTourComponent } from './ProjectionTourComponent';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import ProjectionActionCreator from '../../../actions/ProjectionActionCreator';
import { ProjectionScreen } from './ProjectionScreen';
import { SettingsMainPage } from './SettingsMainPage';
import BrowserUtils from '../../../utils/BrowserUtils';
import LoaderComponent from '../../common/LoaderComponent';
import OrientationSwitch from '../../common/OrientationSwitch';
import NonBCustomerError from '../../common/NonBCustomerError';

class Projections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      demo: ProjectionStore.getHeaderDemoFlag(),
      projectionSummary: ProjectionStore.getProjectionSummary(),
      pageMode: ProjectionStore.getPageMode(),
      pageData: ProjectionStore.getPageData(),
      changeToGrid: false,
      getStatus: ProjectionStore.getStatus(),
    };
    this.onStoreChange = this.onStoreChange.bind(this);
    this.clickDoneOnDemo = this.clickDoneOnDemo.bind(this);
    this.goToAcountViewPage = this.goToAcountViewPage.bind(this);
    this.projectionTourDone = this.projectionTourDone.bind(this);
    this.goToProjectionSettingsPage =
      this.goToProjectionSettingsPage.bind(this);
    this.backToAccountPage = this.backToAccountPage.bind(this);
    this.onclickLeaveSetup = this.onclickLeaveSetup.bind(this);
    this.backToSummary = this.backToSummary.bind(this);
    this.backButtonOnDemoSettings = this.backButtonOnDemoSettings.bind(this);
    this.changePage = this.changePage.bind(this);
    this.getProjectionView = this.getProjectionView.bind(this);
    this.getErrorPageView = this.getErrorPageView.bind(this);
    this.retryServices = this.retryServices.bind(this);
  }

  onStoreChange() {
    this.setState({
      projectionSummary: ProjectionStore.getProjectionSummary(),
      pageMode: ProjectionStore.getPageMode(),
      getStatus: ProjectionStore.getStatus(),
      pageData: ProjectionStore.getPageData(),
    });
  }

  componentWillMount() {
    ProjectionStore.setVariables(false);
    BrowserUtils.setViewPort(1);
  }

  shouldComponentUpdate(newProps, newState) {
    return true;
  }

  getBackButton() {
    if (this.state.loader || this.state.demo) {
      return null;
    } else {
      return <a onClick={this.goToAcountViewPage}> back</a>;
    }
  }
  projectionTourDone() {
    this.setState({
      pageMode: 'demoSettings',
      demo: true,
    });
  }
  goToProjectionSettingsPage() {
    this.setState({
      pageMode: 'settings',
      demo: true,
    });
  }
  changePage() {
    this.setState({
      changeToGrid: !this.state.changeToGrid,
    });
  }
  backToSummary() {
    this.setState({
      pageMode: 'wheel',
      demo: true,
    });
  }
  backToAccountPage() {
    ProjectionActionCreator.requestProjectionSummary(
      AccountsStore.getAccount()
    );
    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
  }
  backButtonOnDemoSettings() {
    this.setState({
      pageMode: 'loader',
    });
    setTimeout(() => {
      InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
    }, 2000);
  }
  getProjectionPages() {
    let onLoad = true;
    let cancelButtonFlag = false;
    switch (this.state.pageMode) {
      case 'demo':
        return (
          <ProjectionTourComponent
            content={this.props.content}
            closed={this.projectionTourDone}
            backButtonOnDemoSettings={this.backButtonOnDemoSettings}
          />
        );
      case 'wheel':
        return (
          <ProjectionScreen
            onLoad={onLoad}
            goToProjectionSettingsPage={this.goToProjectionSettingsPage}
            projectionSummary={this.state.pageData}
            content={this.props.content}
            changeToGrid={this.state.changeToGrid}
            changePage={this.changePage}
            backToSummary={this.backToSummary}
            backToAccountPage={this.backToAccountPage}
          />
        );
      case 'demoSettings':
        return (
          <SettingsMainPage
            content={this.props.content}
            onclickLeaveSetup={this.onclickLeaveSetup}
            backToAccountPage={this.backToAccountPage}
            backToSummary={this.backToSummary}
            pageMode={this.state.pageMode}
            cancelButtonFlag={cancelButtonFlag}
          />
        );
      case 'settings':
        return (
          <SettingsMainPage
            content={this.props.content}
            onclickLeaveSetup={this.onclickLeaveSetup}
            backToAccountPage={this.backToAccountPage}
            backToSummary={this.backToSummary}
            pageMode={this.state.pageMode}
            cancelButtonFlag={!cancelButtonFlag}
            backButtonOnDemoSettings={this.backButtonOnDemoSettings}
          />
        );

      case 'loader':
      default:
        return <LoaderComponent type="large" />;
    }
  }
  onclickLeaveSetup() {
    ProjectionActionCreator.handleProjectionSettingLeaveSetup();
    this.setState({
      pageMode: 'wheel',
    });
  }
  clickDoneOnDemo() {}
  goToAcountViewPage() {
    InternetBankingActions.navigateToWebTask('WEB-TIMELINE');
  }
  getProjectionView() {
    let projClassName = 'main-container projection account-1';
    if (this.state.pageMode === 'demo') {
      projClassName = 'main-container projection projection-demo account-1';
    }
    return (
      <div>
        <Helmet title="Projections" />
        <div className="b container-fluid-full scrollable">
          <div className={projClassName}>{this.getProjectionPages()}</div>
        </div>
      </div>
    );
  }

  retryServices() {
    ProjectionActionCreator.requestProjectionSummary(
      AccountsStore.getAccount()
    );
  }

  getErrorPageView() {
    return (
      <NonBCustomerError
        headerContent=""
        buttonName2={this.props.content.projectionButtonTitle}
        bodyContent1={this.props.content.projectionErrorBody}
        bodyContent2=""
        handleButtonClick2={this.retryServices}
        headerFlag
        hideButton1
        componentName
        page
      />
    );
  }
  render() {
    return (
      <OrientationSwitch
        backToAccountPage={this.backToAccountPage}
        view={
          this.state.getStatus === 408
            ? this.getErrorPageView
            : this.getProjectionView
        }
      />
    );
  }
}

const ConnectedProjections = RequiresAuthenticatedUser(Projections);
export { ConnectedProjections as Projections };
